<ng-container *transloco="let t" class="container">
  <div [class.modal-body]="openInModal">
    @if (openInModal) {
    <div class="d-flex align-items-center pb-4">
      <img src="assets/img/svg/T.svg" alt="Tracey logo">
      <div class="d-flex align-items-start flex-grow-1">
        <div class="fw-semibold title-wrapper line-height-1">
          {{ title ? t(title) : "" }}
        </div>
      </div>
      <div class="pe-20 align-self-start">
        <button type="button" class="btn-close" aria-label="Close" (click)="actionButtonCancel()"></button>
      </div>
    </div>
    }
    <div [class.body-wrapper]="openInModal">
      <form [formGroup]="inputForm">
        @if(!teamMemberEdit && !assignStartNumber) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="raceName" label="app.common.race" class="disabled"></app-input>
        </div>
        }
        @if(isTeam && !assignStartNumber) {
        <div class="col-12 pt-20-10">
          <app-input formControlName="teamName" label="app.common.team.name"></app-input>
        </div>
        }
        @if(!isTeam && !assignStartNumber) {
        <app-register-to-race-item
          [languages]="languages"
          [registerForMySelf]="false"
          [isManagement]="true"
          [race]="race"
          [isEdit]="true"
          [meals]="lookups.meals"
          [tshirtSizes]="lookups.tshirtSizes"
          [countries]="lookups.countries"
          [disciplines]="lookups.disciplines"
          [transports]="lookups.transports"
          [genders]="lookups.genders"
          [currencies]="lookups.currencies"
          [registerHelper]="registerHelper"
          (onChangeEmail)="onEmailChange($event)"
          [index]="index"
          [competitorRegistration]="competitorRegistration"
          [applicationFormSettings]="applicationFormSettings"
          [registerToRaceUserTypeState]="RegisterToRaceUserType.ORGANISER"
          [isTeamRegistration]="false">
        </app-register-to-race-item>
        }
        @if(!teamMemberEdit) {
        <div [class.pt-30-28]="!assignStartNumber">
          @if (!assignStartNumber) {
          <div class="fw-bold">
            <span class="text-uppercase">{{ t('competitor.management.start.info') | uppercase }}</span>
          </div>
          }
        @else {
        <div class="fw-bold pb-20">
          <span class=""><app-language-output [defaultLanguage]="event?.defaultLanguage"
                                              [enLabel]="race?.name"
                                              [hrLabel]="race?.nameEng"
                                              [itLabel]="race?.nameIta" [languages]="languages"
                                              [siLabel]="race?.nameSlo"
                                              [bsLabel]="race?.nameBs"
                                              [srLabel]="race?.nameSr"/></span>
          <br/>
          <span class="">{{ t('competitor.assign.start.number')}}</span>
          <span class="">{{ " " +
          ((!isTeam) ? ((competitor?.firstName ?? "")| titlecase)  + " "  : "") +
          ((competitor?.lastName ?? "") | titlecase)}}</span>
        </div>
        }

          <div class="row">
           @if (!assignStartNumber) {
             <div class="col-6 pt-20-10">
              <app-input formControlName="id" label="app.common.id" class="disabled"></app-input>
            </div>
          }
            <div [class.pt-20-10]="!assignStartNumber" [class.col-6]="raceSettings?.blockStart" [class.col-12]="!raceSettings?.blockStart">
              <app-input formControlName="startNumber" label="competitor.table.start.number"></app-input>
            </div>
            @if(raceSettings?.blockStart) {
            <div class="col-6" [class.pt-20-10]="!assignStartNumber">
              <app-input formControlName="startBlock" label="competitor.table.startBlock"></app-input>
            </div>
            }
          </div>
        </div>
        }

        @if(!teamMemberEdit && !assignStartNumber) {
        <div class="pt-30-28">
          <div class="fw-bold">
            <span class="text-uppercase">{{ t('competitor.management.payment.info') | uppercase }}</span>
          </div>
          <div class="row">
            <div class="col-6 pt-20-10">
              <app-input formControlName="orderNumber" label="competitor.management.order.number"
                         class="disabled"></app-input>
            </div>
<!--            <div class="row">-->
<!--              <div class="col-6 pt-20-10">-->
<!--                <app-select-->
<!--                  formControlName="paymentStatusTracey"-->
<!--                  [displaySelectionAsBadge]="true"-->
<!--                  [items]="[0,1,2,3]"-->
<!--                  [labels]="['account.statements.amountStatus.0', 'account.statements.amountStatus.1', 'account.statements.amountStatus.2', 'account.statements.amountStatus.3' ]"-->
<!--                  [badgeClasses]="['green', 'red-green','orange', 'red',]"-->
<!--                  label="competitor.management.payment.status.tracey">-->
<!--                </app-select>-->
<!--              </div>-->
<!--              <div class="col-6 pt-20-10">-->
<!--                <app-input formControlName="remainingAmountTracey"-->
<!--                           label="competitor.management.remaining.amount.tracey"></app-input>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-6 pt-20-10">-->
<!--                <app-select-->
<!--                  formControlName="paymentStatusOrganiser"-->
<!--                  [displaySelectionAsBadge]="true"-->
<!--                  [items]="[0,1,2,3]"-->
<!--                  [labels]="['account.statements.amountStatus.0', 'account.statements.amountStatus.1', 'account.statements.amountStatus.2', 'account.statements.amountStatus.3' ]"-->
<!--                  [badgeClasses]="['green', 'red-green','orange', 'red',]"-->
<!--                  label="competitor.management.payment.status.organiser">-->
<!--                </app-select>-->
<!--              </div>-->
<!--              <div class="col-6 pt-20-10">-->
<!--                <app-input formControlName="remainingAmountOrganiser"-->
<!--                           label="competitor.management.remaining.amount.organiser"></app-input>-->
<!--              </div>-->
<!--            </div>-->
            <div class="row">
              <div class="col-12 pt-20-10">
                <app-select
                  formControlName="paymentStatus"
                  [displaySelectionAsBadge]="true"
                  [items]="[0,1,2,3]"
                  [labels]="['account.statements.amountStatus.0', 'account.statements.amountStatus.1', 'account.statements.amountStatus.2', 'account.statements.amountStatus.3' ]"
                  [badgeClasses]="['green', 'red-green','orange', 'red',]"
                  label="competitor.management.payment.status">
                </app-select>
              </div>
              <div class="col-12 pt-20-10">
                <app-textarea
                  id="paymentComment"
                  formControlName="paymentComment"
                  rows="5"
                  label="competitor.management.payment.comment">
                </app-textarea>
              </div>
            </div>
          </div>
        </div>
        }

      </form>
    </div>
    @if(openInModal) {
    <div class="d-flex justify-content-center align-items-center pb-40-48">
      <div class="d-flex">
        <div class="pe-3">
          <app-rounded-button [label]="t('app.common.cancel')" [btnClass]="'rounded-button--black-outline'"
                              (onClick)="actionButtonCancel()"></app-rounded-button>
        </div>
        <app-rounded-button [label]="t('app.common.save')" (onClick)="actionButtonSave()"
                            [btnClass]="'rounded-button--solid'"></app-rounded-button>
      </div>
    </div>
    }

  </div>
</ng-container>
